export type GoogleMap = google.maps.Map;
export type GoogleMarker = google.maps.Marker;
export type Autocomplete = google.maps.places.Autocomplete;
export type InfoWindow = google.maps.InfoWindow;

export const wasPreviouslyLoaded = (apiKey: string) => {
  const mapsURL = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.indexOf(mapsURL) === 0) {
      return true;
    }
  }
  return false;
};

export const loadMapApi = (apiKey: string) => {
  const mapsURL = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  const googleMapScript = document.createElement('script');
  googleMapScript.src = mapsURL;
  googleMapScript.async = true;
  googleMapScript.defer = true;
  window.document.body.appendChild(googleMapScript);
  return googleMapScript;
};

export const updateZoomIfNeeded = (map: GoogleMap, zoom: number): void => {
  if (map.getZoom() === zoom) {
    return;
  }
  map.setZoom(zoom);
};

export const updateMarkerIfNeeded = (
  map: GoogleMap,
  marker: GoogleMarker | undefined,
  lat: number,
  lng: number,
) => {
  const position = marker?.getPosition();
  if (!position) return;
  if (position.lat() !== lat || position.lng() !== lng) {
    marker?.setPosition({ lat, lng });
  }
};
